// @mui
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
// components
import HeroSliderNavigation from '@/components/common/HeroSliderNavigation';

type Props = {
  industryInterests?: any[];
  searchByIndustryInterests?: (id: number) => void;
};

export default function ContentsNavigation({
  industryInterests,
  searchByIndustryInterests,
}: Props) {
  return (
    <Box maxWidth="xl">
      <HeroSliderNavigation />
      <Box sx={{ textAlign: 'center' }}>
        {industryInterests?.map(({ id, title }) => (
          <Chip
            key={`search-tag-${id}`}
            color="primary"
            variant="outlined"
            sx={{ m: 1, p: 2, fontWeight: 'bold' }}
            label={title}
            onClick={
              searchByIndustryInterests ? () => searchByIndustryInterests(id ?? 0) : () => {}
            }
          />
        ))}
      </Box>
    </Box>
  );
}
